import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spin, Icon } from 'antd';
import store from '../../../../../../redux/configureReduxStore';

export const showBookingOrder = payload => store.dispatch({ type: 'CHANGE_MAX_OPTRA_STATUS', payload });

const mapStateToProps = (state) => {
    const { order_status, date_type } = state.Leads.Lead_profile.Lead_transport;
    const { is_part_ex } = state.Leads.Lead_profile.Ref_bike_lead.part_ex;
    return { order_status, date_type, is_part_ex };
};

export default connect(mapStateToProps, null)(class ShowBookingOrderStatus extends Component {
    render() {
        if (this.props.date_type === 'DATETIME') {
            return (
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" style={{ fontSize: 38 }} />
                    <h5 style={{ textAlign: 'center', marginTop: 15, fontStyle: 'italic' }}>
                        Transport Order created successfully!
                    </h5>
                    <h6 style={{ textAlign: 'center', marginTop: 10, fontStyle: 'italic' }}>
                        Waiting for approve ...
                    </h6>
                </div>
            );
        }
        return !this.props.order_status
            ? (
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <Spin size="large" tip="Loading" />
                    <h3 style={{ textAlign: 'center', marginTop: 15 }}>Booking Bike With Transport ...</h3>
                </div>
            )
            : (
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" style={{ fontSize: 38 }} />
                    <h5 style={{ textAlign: 'center', marginTop: 15, fontStyle: 'italic' }}>
                        {!this.props.is_part_ex
                            ? `Collection Order created successfully with status ${this.props.order_status.data.maxoptra_orders.collection_order.status} !!!`
                            : 'Collection Order and Collection Delivery Order created successfully'}
                    </h5>
                </div>
            );
    }
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Modals/TransportModalViews/ShowBookingOrder.js